import React from "react";
import ActionMenu from "../../components/Common/ActionMenu";

const QueryActionMenu = ({ query, onOpen, readOnly = false }) => (
  <span className="checklist-review__query-actions">
    <ActionMenu
      label={`query ${query.taskNumber || query.queryNumber || query.id}`}
      actions={[
        { label: "View", icon: <i className="bx bx-show" />, onSelect: () => onOpen(query, "view") },
        ...(!readOnly ? [{ label: "Edit", icon: <i className="bx bx-edit-alt" />, onSelect: () => onOpen(query, "edit") }] : []),
      ]}
    />
  </span>
);

export default QueryActionMenu;
